import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbsenceTooltipComponent } from '@app/shared/absence/absence-tooltip/absence-tooltip.component';
import { TooltipDirective } from '@sb/tooltip';
import { NotificationBadgeComponent } from '@sb/ui/badge';
import type { CalendarDay } from '@sb/ui/calendar';
import { clsx } from 'clsx';

import { EnhancedAbsenceModel } from '../../../../../reducers/orm/absence/absence.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'absence-calendar-day',
  imports: [CommonModule, NotificationBadgeComponent, TooltipDirective, AbsenceTooltipComponent],
  templateUrl: './absence-calendar-day.component.html',
})
export class AbsenceCalendarDayComponent implements OnChanges {
  classes = '';
  styles = {};

  @Input()
  day: CalendarDay;

  @Input()
  absences: EnhancedAbsenceModel[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['absences']) {
      if (this.absences.length === 0) {
        this.classes = clsx({
          'opacity-50': this.day.isOutOfMonth,
        });
        this.styles = {};
        return;
      }

      this.classes = clsx({
        'text-on-color-light': this.absences[0].status !== 'Pending' && this.absences[0].absenteeOption.color_is_dark,
        'opacity-50': this.day.isOutOfMonth,
        'border-2 border-solid': true,
      });
      this.styles = {
        borderColor: this.absences[0].absenteeOption.color,
        backgroundColor: this.absences[0].status !== 'Pending' ? this.absences[0].absenteeOption.color : '',
      };
    }
  }
}
